import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren, inject} from '@angular/core';
import { FilterCheckboxConfiguration } from '@app-model/company';
import { SideFilterTitlesEnum } from '@app-model/filter';
import { UserProfile } from '@app-model/user';
import { CompanyService } from '@app-services/company.service';
import { FilterService } from '@app-services/filter.service';
import { CheckedOptionUtils, TypeCheckOption } from '@app-shared/utils';
import { UniversalStorage } from '@aws-amplify/core';
// import { Subscription } from 'rxjs';
// import { filter } from 'rxjs/operators';
import { Subscription, fromEvent } from 'rxjs';
import { debounceTime,
  map,
  distinctUntilChanged,
  filter } from 'rxjs/operators';
import { CheckboxMatComponent } from '../checkbox-mat/checkbox-mat.component';
import { CheckboxStoreComponent } from '../checkbox-store/checkbox-store.component';


@Component({
    selector: 'app-filter-company',
    templateUrl: './filter-company.component.html',
    styleUrls: ['./filter-company.component.scss'],
    standalone: false
})
export class FilterCompanyComponent implements OnInit {
	companies: any[] = [];
	filterReady = false;
	@Input() userProfile: UserProfile;
	@Output() close = new EventEmitter;
	filter;
	existsCompany = false;
	existsCompanyAll = false;
	sideFilterConfiguration: FilterCheckboxConfiguration[] = [];
	checkUtils: CheckedOptionUtils = new CheckedOptionUtils();
	loading = false;
  searchInput = '';

  @ViewChild('companySearchInput', { static: true }) companySearchInput: ElementRef;

	@ViewChildren(CheckboxStoreComponent)
	checks: CheckboxStoreComponent[];

	@ViewChildren(CheckboxMatComponent)
	matChecks: CheckboxMatComponent[];

	public allSelected: boolean = false;
	public indeterminate: boolean = false;

	private _unsubscribeSearchQuestions: Subscription = null;

	constructor(
		private companyService: CompanyService,
		private filterService: FilterService,
	) {}

	itemChanged(item, event) {
		item.isChecked = event.checked;

		let totalSelected = this.companies.filter(i => i.isChecked).length;
		if (totalSelected === 0) {
			this.allSelected = false;
			this.indeterminate = false;
		} else if (totalSelected > 0 && totalSelected < this.companies.length) {
			this.allSelected = false;
			this.indeterminate = true;
		} else if (totalSelected === this.companies.length) {
			this.allSelected = true;
			this.indeterminate = false;
		}
	}

	toggleSelectAll(event): void {
		let flag = event.checked;
		this.filterService.filterPaneElements.pipe(filter(result => result !== null)).subscribe(([filter, options]) => {
			filter.companies.forEach(a => {
				a.checked = flag;
				if (a.children && a.children.length > 0) {
					a.children.forEach(c => {
						c.checked = flag;
					});
				}
			});
			this.filter = filter.companies;
			this.existsCompany = true;
		});
		if (this.searchInput) {
			this.filterService.initFilterSearch(this.searchInput);
		} else if (this.existsCompanyAll) {
			this.filterService.initFilterAll();
		} else {
			this.filterService.initFilter();
		}
	}

	toggleClearAll() {
		this.searchInput = '';
		this.allSelected = false;
		this.filterService.initFilterSearch(this.searchInput);
	}

	fetchAllCompanys(option?: string) {
		this.searchInput = '';
		if (option == 'yes') {
			this.filterService.initFilterAll();
			this.existsCompanyAll = true;
		} else {
			this.existsCompanyAll = false;
			this.filterService.initFilter();
		}
		this.fillFilterArray();
	}

	ngOnInit(): void {
		this.filterService.initFilter();
		this.fillFilterArray();

    fromEvent(this.companySearchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      // if character length greater then 2
      , filter(res => res.length > 2)
      // Time in milliseconds between key events
      , debounceTime(1000)
      // If previous query is diffent from current
      , distinctUntilChanged()
      // subscription for response
    ).subscribe((text: string) => {
      this.filterService.initFilterSearch(text);
      this.fillFilterArray();
    });
	}

	submit() {
		if (this.getCompanyChecked()) {
			this.setStorageChoiceFilter();
			this.setOptionsInFilterInVariaveisDoFiltro();
		}
		this.searchInput = '';
		this.close.emit();
	}

	clear() {
		this.searchInput = '';
		this.filterService.initFilterSearch(this.searchInput);
		this.fillFilterArray();
	}

	closeModal() {
		this.filterService.changeToogleSidePanelFilterSource(false);
	}

	onSearch() {
    if(this.searchInput.length >=3){
      this.filterService.initFilterSearch(this.searchInput);
      this.fillFilterArray();
    }
	}

	setOptionsInFilterInVariaveisDoFiltro(): void {
		this.filterService.setOnChangesFilterCompany({
			companies: this.filter
		} as any);
	}

	setStorageChoiceFilter(): void {
		if (this.getCompanyChecked()) {
			var universalStorage = new UniversalStorage();
			universalStorage.setItem('filterLastCompanyName', this.getCompanyChecked('name'));
			universalStorage.setItem('filterLastCompanyId', this.getCompanyChecked('id'));
			universalStorage.setItem('filterLastCompanyMatrizId', this.getCompanyChecked('matriz'));
		}
	}

	fillFilterArray(): void {
		this.filterService.filterPaneElements.pipe(filter(result => result !== null)).subscribe(([filter, options]) => {
			this.existsCompany = false;
			this.filter = filter.companies;
		
			this.filterReady = true;
			if (Array.isArray(options)) {
				let filter = this.sideFilterConfiguration.find(s => s.title == SideFilterTitlesEnum.SUB_AREAS);
				if (filter) {
					this.filter[filter.attrFilter] = options;
				}
			}
			if (this.filter.length > 0) {
				this.existsCompany = true;
			}
		});
	}
	getCompanyChecked(index?: string): any {
		var company = null;
		var companyIds = [];
		var companyMatrizIds = [];
		var chave = '';

		this.filter.forEach(c => {
			if (c.children.length) {
				c.children.forEach(children => {
					if (children.checked) {
						if (c.companyId == children.option.companyId) {
							companyMatrizIds.push(children.option.companyId);
						}
						chave = c.option.companyName;
						companyIds.push(children.option.companyId);
					}
				});
			} else {
				if (c.checked) {
					chave = c.option.companyName;
					companyIds.push(c.option.companyId);
					companyMatrizIds.push(c.option.companyId);
				}
			}
		});
		if (companyIds.length) {
			company = [chave, companyIds];
			if (index == 'name') {
				return chave;
			} else if (index == 'id') {
				return companyIds;
			} else if (index == 'matriz') {
				return companyMatrizIds;
			} else {
				return true;
			}
		}
		return company;
	}

	private syncParentCompanyState(): void {
		this.filter.forEach(company => {
			if (company.children?.length) {
				company.checked = company.children.every(child => child.checked);
			}
		});
	}

	noCompanyChecked(nodes) {
		let contChecked = 0;

		nodes.forEach(node => {
			if (node.checked) {
				contChecked++;
			}
		});
		this.filter.forEach(c => {
			if (c.checked) {
				contChecked++;
			}
			c.children.forEach(children => {
				if (children.checked) {
					contChecked++;
				}
			});
		});
		return contChecked === 0 ? true : false;
	}

	onChangeCheckbox(node) {
		let nodes = Array.isArray(node) ? node : [node];
    //console.log('nodes',nodes)
		const type = nodes[0].type;

		if (type === TypeCheckOption.COMPANY) {
			if (this.noCompanyChecked(nodes)) {
				try {
					this.filter.forEach(c => {
						c.checked = false;
						c.children.forEach(children => {
							children.checked = false;
						});
					});
				}
				catch(e) {
					console.warn(e);
				}
			} else {

        nodes.forEach(node => {
          this.filter.forEach(c => {
              //c.checked = false;

              if (node?.children?.length){
                c.children.forEach(children => {
                  node.children.forEach(itemChildren => {
                    if (children.companyId === itemChildren.companyId) {
                      children.checked = itemChildren.checked;
                    }
                  });
                });
              } else {
                if (c.companyId === node.companyId) {
                  c.checked = node.checked;
                }

                c.children.forEach(children => {
                  if (children.companyId === node.companyId) {
                    children.checked = node.checked;
                  }
                });

              }
          });
        });

			}

			this.syncParentCompanyState();
    
			let uniqueCompany = false;
			let companyIdNode = null;

			if (!Array.isArray(node) && node.checked) {
				uniqueCompany = true;
				companyIdNode = node.companyId;
			}
		}
	}
}
